import {
  IAccountingRemittanceRepository,
  IGetAccountingRemittancesRepositoryParams,
  IGetAccountingRemittancesRepositoryResponse,
} from "@/core/repositories/accounting/IAccountingRemittance.repository";

export class GetAccountingRemittancesUseCase {
  constructor(private readonly repository: IAccountingRemittanceRepository) {}

  public async execute(
    params: IGetAccountingRemittancesRepositoryParams,
    refetch: boolean = false
  ): Promise<IGetAccountingRemittancesRepositoryResponse> {
    return this.repository.getAccountingRemittances(params, refetch);
  }
}
